module.exports = __webpack_public_path__ + "static/media/cardLeaf.6bde0578.svg";